module.exports = __webpack_public_path__ + "static/img/salon_apply_zh.c32a23d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/salon_apply_zh.png
// module id = VyF+
// module chunks = 34